<div
  #swiper 
  class="carousel-loader__swiper swiper" 
>
  <ul class="swiper-wrapper">
    @for(image of getListOfImages(); track image) {
      <li class="swiper-slide">
        <div class="image-container">
          <img 
            [src]="image" 
            [alt]="('Imagen de carga' | translate) + (isPointListLoader() ? ' ' + getPointLoaderName(image) : '')" 
          />
        </div>
      </li>
    }
  </ul>
</div>